import WarehousesDropdown from 'components/WarehousesDropdown/WarehousesDropdown';
import classNames from 'classnames';
import Label from 'components/Label/Label';
import { useWarehouses } from 'hooks/redux/useWarehouses';
import './warehouse-filter.scss';

export default function WarehouseFilter({
  currentWarehouse,
  isSorter,
  clearable = true,
  inline = false,
  onChangeWarehouse = () => {},
}) {
  const { warehouses } = useWarehouses();

  return (
    <div
      className={classNames('warehouse-filter', {
        'warehouse-filter--inline': inline,
      })}
    >
      <Label small className="warehouse-filter__label">
        Almacén
      </Label>
      <WarehousesDropdown
        warehouses={
          !!isSorter
            ? warehouses.filter((warehouse) => !!warehouse.has_sorter)
            : warehouses
        }
        className="warehouse-filter__dropdown"
        clearable={clearable}
        value={currentWarehouse || null}
        onChange={onChangeWarehouse}
      />
    </div>
  );
}
